import {CREATE_INFO} from '../actions/types';

const initialState = {
  info: '',
  status: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CREATE_INFO:
      return {
        info: action.payload,
      };
    default:
      return state;
  }
}
